import React, { useContext } from 'react'
import { Link } from '@paypalcorp/pp-react'
import { get } from 'lodash'
import { getActionProps } from '../../../../../lib/getActionProps'
import { modalContext } from '../../../../../contexts/ModalContext/ModalContext'
import {
  Action,
  ActionHandler,
  HandleClick,
  ModalContextDispatch
} from '../../../types/ShoppingPageType'
import { useLocatorContext } from '../../../../../contexts/locator'
import { LOCATORS } from '../../../../../constants/automation'

interface LinkProps {
  secondary?: boolean
  inverse?: boolean
  className?: string
  leftIcon?: React.ReactNode
}

interface Props extends LinkProps {
  isVisible?: boolean
  actions?: Action[] | null
  modalDispatch?: ModalContextDispatch
  feedbackModalHandler?: ActionHandler
  privacyDisclosureModalHandler?: ActionHandler
  dismissHandler?: ActionHandler
  onClick?: HandleClick
}

const ActionLink = ({
  secondary,
  inverse,
  className,
  leftIcon,
  isVisible = true,
  actions,
  feedbackModalHandler,
  privacyDisclosureModalHandler,
  dismissHandler,
  onClick
}: Props) => {
  const context = useContext(modalContext)
  const { getLocatorProps } = useLocatorContext(LOCATORS.ACTION_LINK)

  const action: Action | null = get(actions, '[0]') || null
  if (!action || !isVisible) return null

  const linkClassName = className ? `action-link ${className}` : 'action-link'

  const { title, isButton, href, target, handleLinkClick, handleButtonClick } =
    getActionProps({
      action,
      modalContext: context,
      feedbackModalHandler,
      privacyDisclosureModalHandler,
      dismissHandler,
      onClick
    })

  const buttonProps = {
    as: 'button',
    onClick: handleButtonClick
  }
  const linkProps = {
    href,
    target,
    onClick: handleLinkClick
  }
  return (
    <Link
      {...getLocatorProps()}
      inverse={inverse}
      secondary={secondary}
      leftIcon={leftIcon}
      className={linkClassName}
      theme="v2"
      {...(isButton ? buttonProps : linkProps)}
    >
      {title}
    </Link>
  )
}

export default ActionLink
